import { Component, ElementRef, ViewChild } from '@angular/core';
import { CtaSectionComponent } from "../../cta-section/cta-section.component";


@Component({
  selector: 'app-external-cfo',
  standalone: true,
  imports: [CtaSectionComponent],
  templateUrl: './external-cfo.component.html',
  styleUrl: './external-cfo.component.css',
})
export class ExternalCfoComponent {
  @ViewChild('servicesSection') servicesSection!: ElementRef;

  isVisible = false;
  private observer: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    if (this.servicesSection?.nativeElement) {
      this.observer.observe(this.servicesSection.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
